'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _config = require('../../../redux/modules/config');

var _modal = require('../../../redux/modules/modal');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _user = require('../../../redux/modules/user');

var _LAFooter = require('./LAFooter');

var _LAFooter2 = _interopRequireDefault(_LAFooter);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        baseUrl: (0, _config.getBaseUrl)(state),
        classicBaseUrl: (0, _config.getClassicBaseUrl)(state),
        userData: (0, _user.getUserData)(state)
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        openDownloadMobileModal: _modal.openDownloadMobileModal,
        openHealthcheckModal: _modal.openHealthcheckModal
    }, dispatch);
};

var LAFooterContainer = function (_PureComponent) {
    (0, _inherits3.default)(LAFooterContainer, _PureComponent);

    function LAFooterContainer() {
        (0, _classCallCheck3.default)(this, LAFooterContainer);
        return (0, _possibleConstructorReturn3.default)(this, (LAFooterContainer.__proto__ || (0, _getPrototypeOf2.default)(LAFooterContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(LAFooterContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                userData = _props.userData;


            return (0, _jsx3.default)(_LAFooter2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                openDownloadMobileModal: this.props.openDownloadMobileModal,
                openHealthcheckModal: this.props.openHealthcheckModal,
                userData: userData
            });
        }
    }]);
    return LAFooterContainer;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LAFooterContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/LAFooterContainer.js
// module id = lT8R
// module chunks = 57